function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M106.3 120.4h70.9V63.7h-70.9v56.7zm14.2-42.5H163v28.3h-42.5V77.9zm121.3-43.7L141.7 0 41.6 34.2 0 117.1v138h92.1v-85h99.3v85h92.1v-138l-41.7-82.9zm13.3 192.6h-35.4v-85h-156v85H28.3V123.9l33.4-66.4 80-26.7 80 26.7 33.4 66.4v102.9z"
})));